import React, { useState, useEffect, useMemo } from 'react';
import { ScrollView, TouchableOpacity, View } from 'react-native'

import tw from '../../../../../styles/tailwind';
import Text from '../../../../../components/Text';
import Icon from '../../../../../components/IcomoonIcon';
import { useController, useForm, useWatch } from 'react-hook-form';
import DateSelector from '../../../../../components/Forms/DateSelector';
import { FooterButtons, TabsSelector } from '../NewGuestPassModal';
import { Ionicons } from '@expo/vector-icons';


import dayjs from 'dayjs';
import isTomorrow from 'dayjs/plugin/isTomorrow'
import isToday from 'dayjs/plugin/isToday'
dayjs.extend(isTomorrow);
dayjs.extend(isToday);


function DaysSelector({ onChange, initialValue }) {
  const [selectedDays, setSelectedDays] = useState(initialValue ?? {
    0: false, 1: false, 2: false, 3: false, 4: false, 5: false, 6: false,
  });

  function renderDay(label, dayIndex) {
    const isSelected = selectedDays[dayIndex];
    const isWeekend = dayIndex >= 5

    return (
      <TouchableOpacity
        style={tw.style(
          `row justify-between px-6 py-4 border-b border-primary-200`,
          // isWeekend && `bg-gray-300`,
          // isSelected && `bg-secondary`,
        )}
        onPress={() => {
          const newSelected = {
            ...selectedDays,
            [dayIndex]: !isSelected,
          }

          setSelectedDays(newSelected)
          onChange?.(newSelected)
        }}
      >
        <Text style={tw.style(`text-gray-500 font-600`, isSelected && `text-primary-800`)}>{label}</Text>

        <View style={tw.style(`h-6 w-6 bg-gray-300 rounded-full items-center justify-center`, isSelected && `bg-primary`)}>
          {
            isSelected &&
             <Ionicons name='checkmark' color={'#fff'} size={16} />
          }
        </View>
      </TouchableOpacity>
    )
  }

  return (
    <View style={tw`bg-white rounded-2xl border border-primary-200`}>
      {renderDay("Lunes", 0)}
      {renderDay("Martes", 1)}
      {renderDay("Miércoles", 2)}
      {renderDay("Jueves", 3)}
      {renderDay("Viernes", 4)}
      {renderDay("Sábado", 5)}
      {renderDay("Domingo", 6)}
    </View>
  )
}


export default function PassDatesStep({ control, setValue, name=null, onNextPressed, onBackPressed, isSubmitting=false, isLastStep=true }) {
  const [minimumLimitDate, setMinimumLimitDate] = useState(new Date());

  const periodicity: ('one_time' | 'recurrent') = useWatch({
    control,
    name: "periodicity",
  })

  const entry_date = useWatch({
    control,
    name: "entry_date",
  })

  let entryDateStr =  ""

  if(entry_date){
    const entryDate = dayjs(entry_date)
    if (entryDate.isToday()){
      entryDateStr = "Hoy"
    } else if (entryDate.isTomorrow()){
      entryDateStr = "Mañana"
    }else{
      entryDateStr = entryDate.format('ddd D MMM YYYY')
    }
  }

  const entry_date_limit = useWatch({
    control,
    name: "entry_date_limit",
  })

  
  const entryDateLimitStr = entry_date_limit ? dayjs(entry_date_limit).format('ddd D MMM YYYY') : ""
  const initialValidDays = { 0: true, 1: true, 2: true, 3: true, 4: true, 5: true, 6: true, }

  //!
  const valid_days = useWatch({
    control,
    name: "valid_days",
    defaultValue: initialValidDays,
  })
  const hasValidDays = Object.keys(valid_days).some(dayIndex => !!valid_days[dayIndex])


  useEffect(() => {
    setMinimumLimitDate(entry_date)

    if (entry_date_limit < entry_date){
      setValue('entry_date_limit', entry_date)
    }
  }, [entry_date]);


  const canSubmit = (
    (periodicity == 'one_time' && entry_date) 
    || (periodicity == 'recurrent' && hasValidDays && entry_date && entry_date_limit)
  )


  return (
    <>
      <ScrollView style={tw`flex-1`} contentContainerStyle={tw`pb-4`}>
        <Text style={tw`text-white text-center text-xl font-500 mb-8`}>¿Esta visita se repetirá?</Text>

        <TabsSelector
          onChange={(periodicity) => setValue('periodicity', periodicity)}
          values={[
            { key: 'one_time', title: 'Única vez' },
            { key: 'recurrent', title: 'Recurrente' },
          ]}
          initialValue={periodicity}
        />

        <View style={tw`px-6 mt-8 mb-8`}>
          {
            periodicity === 'one_time' ?
              <Text style={tw`text-white text-center text-xl`}>Tu visita solo podrá acceder el día seleccionado</Text>
              :
              <Text style={tw`text-white text-center text-xl`}>Elige un lapso o días específicos de acceso</Text>
          }
        </View>


        {
          periodicity == "one_time" &&
            <View style={tw`bg-primary-100 rounded-2xl px-4 py-4`}>
              <Text style={tw`text-center text-lg text-primary-800 font-500 mb-5`}>Elige el día</Text>

              <View style={tw`row justify-between bg-white rounded-xl border border-primary-300 pl-6 pr-4 py-4`}>
                <Text style={tw`text-gray-600 font-500`}>Día</Text>

                <View style={tw`row`}>
                  <Text style={tw`text-gray-600 font-500 text-lg mr-2 text-secondary`}>{entryDateStr}</Text>

                  <Icon name='chevron-right' size={12} style={tw`-mt-1`} color={tw.color('secondary')} />
                </View>

                {/* Input oculto */}
                <View style={tw`mb-0 absolute left-0 right-0 top-0 bottom-0`}>
                  <DateSelector
                    style={tw`mb-0 h-100% opacity-2`}
                    minimumDate={new Date(Date.now())}
                    control={control}
                    name="entry_date"
                    rules={{ required: true }}
                  />
                </View>
              </View>
            </View>
        }
        
        {
          periodicity == "recurrent" &&
            <View style={tw`bg-primary-100 rounded-2xl px-4 py-4 gap-y-8`}>
              {/* 
                Periodo de fechas 
              */}
              <View>
                <Text style={tw`text-center text-lg text-primary-800 font-500 mb-5`}>Elige el periodo</Text>

                <View style={tw`gap-y-3`}>
                  {/* Selector Desde */}
                  <View style={tw`row justify-between bg-white rounded-xl border border-primary-300 pl-6 pr-4 py-4`}>
                    <Text style={tw`text-gray-600 font-500`}>Desde</Text>

                    <View style={tw`row`}>
                      <Text style={tw`text-gray-600 font-500 text-lg mr-2 text-secondary`}>{entryDateStr}</Text>

                      <Icon name='chevron-right' size={12} style={tw`-mt-1`} color={tw.color('secondary')} />
                    </View>

                    {/* Input oculto */}
                    <View style={tw`mb-0 absolute left-0 right-0 top-0 bottom-0`}>
                      <DateSelector
                        style={tw`mb-0 h-100% opacity-2`}
                        minimumDate={new Date()}
                        control={control}
                        name="entry_date"
                        rules={{ required: true }}
                      />
                    </View>
                  </View>


                  {/* Selector Hasta */}
                  <View style={tw`row justify-between bg-white rounded-xl border border-primary-300 pl-6 pr-4 py-4`}>
                    <Text style={tw`text-gray-600 font-500`}>Hasta</Text>

                    <View style={tw`row`}>
                      <Text style={tw`text-gray-600 font-500 text-lg mr-2 text-secondary`}>{entryDateLimitStr}</Text>

                      <Icon name='chevron-right' size={12} style={tw`-mt-1`} color={tw.color('secondary')} />
                    </View>

                    {/* Input oculto */}
                    <View style={tw`mb-0 absolute left-0 right-0 top-0 bottom-0`}>
                      <DateSelector
                        style={tw`mb-0 h-100% opacity-2`}
                        minimumDate={minimumLimitDate}
                        control={control}
                        name="entry_date_limit"
                        rules={{ required: true }}
                      />
                    </View>
                  </View>
                </View>
              </View>

              {/* 
                Dias de ingreso 
              */}
              <View style={tw``}>
                <Text style={tw`text-center text-lg text-primary-800 font-500 mb-5`}>Días de ingreso</Text>
        
                <DaysSelector
                  onChange={days => setValue('valid_days', days)}
                  initialValue={initialValidDays}
                />
              </View>
            </View>
        }
      </ScrollView>

      <FooterButtons
        onBackPressed={onBackPressed}
        onNextPressed={onNextPressed}
        nextDisabled={!canSubmit}
        lastStep={isLastStep}
        isSubmitting={isSubmitting}
      />
    </>
  )
}